module.exports = __webpack_public_path__ + "img/ic_yinpin.6303fa9c.svg";